<template>
  <div>
    <block-head
      title="信息发布"
      subtitle="/ 深度聚焦  即刻掌握"
      icon="link"
      :more-btn-url="moreBtnUrl"
    />
    <div class="news f-b-c">
      <image-news :list="dataListXwlb[NAV_MENU_CODE.XWLB]" :column-code="activeTab" />
      <div class="tab-news f-column-b ml-20">
        <div class="tab-head f-b-c">
          <ul class="tabs f-start-c">
            <li v-for="(menu, index) in menuTabs" :key="menu.code" class="tab-item-btn" :class="{active: activeTab === menu.code}" @click="changeTab(menu.code)"><span>{{ menu.title }}</span>
              <!-- 添加竖线 -->
              <div v-if="index !== menuTabs.length - 1" class="vertical-line" />
            </li>
          </ul>
        </div>
        <div class="tab-panel">
          <div class="panels" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
            <div v-for="menu in menuTabs" :key="menu.code + '_panel'" class="tab-panel-item">
              <ul class="news-list">
                <li v-for="data in dataList[menu.code]" :key="data.id" class="news-item f-b-c">
                  <Link class="f-b-c" :to="{path:`/info/detail/${menu.code}`, query: {id: data.id}}" :title="data.title" target="_blank">
                    <span class="text-cut">{{ data.title }}</span>
                    <span class="time fc99 pl-10">{{ data.releaseTime | formatterDate }}</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageNews from "@/views/home/components/ImageNews.vue";
import { NAV_MENU_CODE } from "@/utils/constant";
import infoApi from "@/api/information";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import { formatterDate } from "@/filters";
import BlockHead from "@/views/home/components/BlockHead.vue";
import { parseTime } from "@/filters";
export default {
  name: "TabNews",
  components: { ImageNews, Link, BlockHead },
  props: {
  },
  data() {
    return {
      activeTab: NAV_MENU_CODE.XTDT,
      menuTabs: [
        { title: "新闻动态", code: NAV_MENU_CODE.XTDT },
        { title: "通知公告", code: NAV_MENU_CODE.NOTICES }
        // { title: "招商公告", code: NAV_MENU_CODE.ZSGG }
      ],
      NAV_MENU_CODE,
      dataList: {
        [NAV_MENU_CODE.XTDT]: [],
        [NAV_MENU_CODE.NOTICES]: []
        // [NAV_MENU_CODE.ZSGG]: []
      },
      dataListXwlb: {
        [NAV_MENU_CODE.XWLB]: []
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {
    currentIndex() {
      return this.menuTabs.findIndex(item => item.code === this.activeTab)
    },
    moreBtnUrl() {
      return "/info/list/" + this.activeTab
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
    this.loadListDataXwlb()
  },
  // 方法集合
  methods: {
    formatterDate,
    changeTab(code) {
      this.activeTab = code
    },
    loadListData() {
      const params = {
        pageNo: 1,
        pageSize: 5
      };
      Promise.all([
        infoApi.page({ ...params, columnId: this.$getMenuIdByCode(NAV_MENU_CODE.XTDT) }),
        infoApi.page({ ...params, columnId: this.$getMenuIdByCode(NAV_MENU_CODE.NOTICES) })
        // infoApi.page({ ...params, columnId: this.$getMenuIdByCode(NAV_MENU_CODE.ZSGG) })
      ]).then(([platformUpdates = {}, notices = {}, zsgg = {}]) => {
        this.dataList = {
          [NAV_MENU_CODE.XTDT]: platformUpdates.data?.list ?? [],
          [NAV_MENU_CODE.NOTICES]: notices.data?.list ?? []
          // [NAV_MENU_CODE.ZSGG]: zsgg.data?.list ?? []
        }
      })
    },
    loadListDataXwlb() {
      const params = {
        pageNo: 1,
        pageSize: 5,
        coverImageHas: true
      };
      Promise.all([
        infoApi.page({ ...params, columnId: this.$getMenuIdByCode(NAV_MENU_CODE.XWLB) })
      ]).then(([xwlb = {}]) => {
        xwlb.data?.list.forEach(e => {
          e.releaseTime = parseTime(e.releaseTime, "{y}-{m}-{d}")
          e.formatterDate = parseTime(e.formatterDate, "{y}-{m}-{d}")
        })
        this.dataListXwlb = {
          [NAV_MENU_CODE.XWLB]: xwlb.data?.list ?? []
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.news{
  padding-top: 20px;
	height: 330px;
}

.tab-news{
  height: 300px;
  width:380px;
  .tab-head{
    height: 32px;
    display: flex;
    justify-content: flex-end;
    .tabs{
      overflow: visible;
      border: 1px solid #ddd;
      .tab-item-btn{
        position: relative;
        width: 96px;
        height: 30px;
        cursor: pointer;
        color: #333;
        text-align: center;
        line-height: 30px;
        .vertical-line {
          width: 1px;
          height: 10px;
          background-color: #ddd;
          position: absolute;
          right: -1px;
          top: 10px
        }
        &:hover{
          color: $--color-primary;
        }
        &.active{
          color: #fff;
          background-color: $--color-primary;
          border-color: $--color-primary;
        }

      }
    }
  }

  .tab-panel{
    flex: 1;
    width: 100%;
    overflow: hidden;
    .panels{
      display: flex;
      transition: transform 0.3s ease-in-out;
    }
    .tab-panel-item{
      width: 100%;
      height: 100%;
      flex-shrink: 0;
      .news-list{
        width: 100%;
        height: 100%;
        padding-top: 8px;
        .news-item{
          position: relative;
          padding-left:14px;
          padding-bottom: 13px;
          line-height: 27px;
          margin: 13px 0 0 0;
          border-bottom: 1px dashed #ddd;
          &::before{
            content: '';
            display: block;
            width: 5px;
            height: 5px;
            background-color: #999;
            position: absolute;
            left: 0;
            top: 40%;
            transform: translateY(-50%);
          }
          a{
            width: 100%;
            color: #333;
            .text-cut{
              flex: 1;
              display: block;
              font-size: 16px;
            }
            .time{
            }
          }
          &:hover{
            &:before{
              background-color: $--color-primary;
            }
            a{
              color: $--color-primary;
            }
          }
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
